export const BREAKPOINTS = {
  MOBILE: 960,
} as const

export const RESPONSIVE_HEIGHTS = {
  CHAT_MIN: 400,
  CHAT_AREA_MAX: 300,
  CHAT_AREA_MIN: 200,
  FOLLOWUP_CALC_OFFSET: 400,
} as const
